import Radio from '@components/Radio/Radio';

import styles from '../UpgradeDialog.module.scss';

interface IntervalProps {
  name: string;
  pricing: React.ReactElement;
  costSaving?: React.ReactElement;
  selected: boolean;
  onSelect: () => void;
}

const Interval: React.FC<React.PropsWithChildren<IntervalProps>> = ({
  name,
  costSaving,
  pricing,
  selected,
  onSelect,
}) => {
  return (
    <label className={styles['interval']}>
      <Radio checked={selected} onChange={() => onSelect()} />
      <div className={styles['interval-details']}>
        <div className={styles['interval-name-container']}>
          <span className={styles['interval-name']}>{name}</span>
          {!!costSaving && <span className={styles['interval-cost-saving-container']}>{costSaving}</span>}
        </div>
        <div className={styles['interval-pricing-container']}>{pricing}</div>
      </div>
    </label>
  );
};

interface IntervalPricingProps {
  primaryPrice: string;
  secondaryPrice?: string;
  hasCondition?: boolean;
}

const IntervalPricing: React.FC<React.PropsWithChildren<IntervalPricingProps>> = ({
  primaryPrice,
  secondaryPrice,
  hasCondition = false,
}) => (
  <div className={styles['interval-pricing']}>
    <span className={styles['interval-price-primary']}>
      {primaryPrice}
      {hasCondition && <span className={styles['interval-price-asterisk']}>*</span>}{' '}
    </span>
    {secondaryPrice && <span className={styles['interval-price-secondary']}>({secondaryPrice})</span>}
  </div>
);

export { Interval, IntervalPricing };
